export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '久久插插接件适用于哪些行业和场景？',
    answer: '久久插产品线覆盖工业级重型、防振自锁、高速数据、防水户外、微型精密和模块化定制六大系列，广泛应用于重型机械制造、轨道交通、风力发电、5G通信基站、航空航天、医疗器械、工业机器人、户外照明等数十个行业领域。无论您的应用场景多么特殊，久久插都能提供匹配的插接解决方案。'
  },
  {
    question: '久久插插接件的使用寿命有多长？',
    answer: '久久插产品的机械插拔寿命普遍超过 10,000 次，在正常使用和定期维护条件下，设计使用寿命可达 15-20 年。久久插工业级系列的接触可靠性达 99.999% 以上，防振自锁系列通过百万次振动测试零失效。具体使用寿命还与工作环境和使用频率密切相关，久久插技术团队可为您提供针对性的寿命评估。'
  },
  {
    question: '如何获得久久插产品的技术支持和选型建议？',
    answer: '您可以通过久久插官网的在线咨询、服务热线 400-888-9999 或发送邮件至 support@jiujiucha.com 联系我们的技术团队。我们将根据您的具体应用场景、电气参数和环境条件，提供专业的产品选型建议和技术方案。久久插还提供免费样品测试服务，让您在实际工况下验证产品性能。'
  },
  {
    question: '久久插支持产品定制吗？定制周期需要多久？',
    answer: '支持。久久插模块化定制系列提供灵活的定制服务，可根据您的需求配置电源、信号、气动、光纤等多种连接模块。对于标准定制需求，交期通常在 7-15 个工作日；复杂定制项目根据具体需求评估交期。久久插配备专业的定制化设计团队，从需求沟通到方案确认再到批量交付，全程一对一服务。'
  },
  {
    question: '久久插产品的质量认证情况如何？',
    answer: '久久插全系列产品均通过 ISO 9001 质量管理体系认证，相关产品还获得了 CE、UL、RoHS、REACH 等国际权威认证。久久插工业级系列符合 MIL-STD-810G 军用标准，微型精密系列符合 AS9100 航空航天质量标准。所有的认证文件和测试报告都可按客户要求提供查阅。'
  },
  {
    question: '久久插插接件的售后服务包含哪些内容？',
    answer: '久久插为用户提供完善的售后服务体系：产品质保期内免费维修或更换；全国主要城市设有技术服务网点，提供 48 小时内上门服务；7×24 小时技术热线支持；定期回访与维护提醒；提供备品备件快速供应服务。久久插的售后服务团队由经验丰富的工程师组成，确保每一位客户都能获得及时、专业的技术支持。'
  },
  {
    question: '久久插插接件在极端温度环境下表现如何？',
    answer: '久久插产品具有优异的宽温域适应性。标准工业级产品耐温范围为 -40°C 至 +125°C，防水户外系列耐温范围可达 -55°C 至 +150°C。久久插在关键锁止部位采用自主研发的弹性自适应复合材料，在全温域范围内保持稳定的弹性模量，确保锁紧力不因温度变化而波动。针对特殊极端温度需求，久久插还可提供定制化解决方案。'
  }
];